import { SceneElement } from '@egr/wcf/modules/core/mdl';
import { AbstractInteractorTool } from './tools';
import { Wall } from '../mdl/Wall';
import { WallOpening } from '../mdl/WallOpening';
import { CoordinatesType } from "@egr/wcf/modules/core/view/View";
export class InsertWallOpening extends AbstractInteractorTool {
    constructor(pRoomManager, pType) {
        super(pRoomManager);
        this.mType = pType;
        this.mWall = null;
        this.mPickedPos = null;
    }
    hasToStart() {
        let tSel = this.mRoomManager.app.model.selection;
        if (tSel.length == 1) {
            if (tSel[0] instanceof Wall || tSel[0] instanceof WallOpening) {
                if (tSel[0] instanceof Wall)
                    this.mWall = tSel[0];
                else if (tSel[0].wall != null)
                    this.mWall = tSel[0].wall;
                this.finish();
                return (false);
            }
            return (true);
        }
        return (true);
    }
    stop() {
        super.stop();
    }
    handlePointerDown(pEvent, pState) {
        super.handlePointerDown(pEvent, pState);
        if (!pState.isPrimaryPointer(pEvent)) {
            return;
        }
    }
    handlePointerUp(pEvent, pState) {
        if (!pState.isPrimaryPointer(pEvent)) {
            return;
        }
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tElement = this.getPickedElement(tPointer.position, !tPointer.isMousePointer, undefined);
        if (tElement == null ||
            (!(tElement instanceof Wall) && !(tElement instanceof WallOpening))) {
            this.finish();
            return;
        }
        if (tElement instanceof WallOpening) {
            if (tElement.wall != null) {
                this.mWall = tElement.wall;
                this.mPickedPos = null;
            }
        }
        else if (tElement instanceof Wall) {
            this.mWall = tElement;
        }
        this.finish();
    }
    handlePointerMove(pEvent, pState) {
        if (!pState.isPrimaryPointer(pEvent) && !pState.isMouseHoverPointer(pEvent))
            return;
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        //
    }
    finish() {
        if (this.mWall == null) {
            this.stop();
            return;
        }
        this.mRoomManager.insertWallOpening(this.mType, this.mWall, this.mPickedPos);
        this.stop();
    }
    getPickedElement(pPos, pUseFrustum, rPickPos) {
        let tView = this.mView;
        if (tView == null)
            tView = this.mRoomManager.hoverView;
        if (tView == null)
            return (null);
        let tPickInfo = null;
        if (pUseFrustum)
            tPickInfo = tView.pickSceneWithFrustum(pPos, 30, 30, CoordinatesType.Client);
        else
            tPickInfo = tView.pickScene(pPos, CoordinatesType.Client);
        if (tPickInfo != null && tPickInfo.hit && tPickInfo.pickedMesh != null) {
            this.mPickedPos = tPickInfo.pickedPoint;
            if (this.mPickedPos != null)
                this.mPickedPos.y = 0;
            return (SceneElement.FromNode(tPickInfo.pickedMesh, true));
        }
        return (null);
    }
}
